import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockAssetEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createGetAssetByIdUseCase({ stockRepository }: Deps) {
  return async function getAssetById(id: string): Promise<StockAssetEntity | null> {
    return stockRepository.getAssetById(id);
  };
}
